import { connect } from 'react-redux';

import get from 'lodash/get';
import PropTypes from 'prop-types';

import VisitorLogTableComponent from './VisitorLogTableComponent';

import { SET_LIST_PARAMS } from '../../actionConstants';
import { getVisitorsLog } from './actionCreators';

import { getTodayCount } from '../../utils';

const LIST_KEY = 'visitorProfileLog';

const VisitorProfileLogTableContainer = (props) => {
  const { onGetVisitorsLog, listParams } = props;
  const onExport = (paginationParams) => {
    const queryParams = { ...listParams, ...paginationParams };
    return onGetVisitorsLog(queryParams);
  };
  return <VisitorLogTableComponent {...props} onExport={onExport} />;
};

VisitorProfileLogTableContainer.propTypes = {
  onGetVisitorsLog: PropTypes.func,
  listParams: PropTypes.instanceOf(Object),
};

const mapStateToProps = (state) => {
  const { visitorLog, buildings } = state;
  return {
    items: visitorLog,
    listKey: LIST_KEY,
    listParams: get(state, `lists.${LIST_KEY}`, {}),
    isVisitorProfile: true,
    buildings,
  };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  onLoad: () => {},
  getItems: (queryParams = {}) => {
    const ownQueryParams = queryParams;
    ownQueryParams.visitor = get(ownProps, 'visitorId');
    getTodayCount(getVisitorsLog, dispatch, ownQueryParams);
    getVisitorsLog(dispatch, ownQueryParams);
  },
  onGetVisitorsLog: (queryParams) =>
    getVisitorsLog(dispatch, queryParams, true),
  setListParams: (queryParams) =>
    dispatch({
      type: SET_LIST_PARAMS,
      listKey: LIST_KEY,
      queryParams,
    }),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(VisitorProfileLogTableContainer);
